import {InjectionToken} from '@angular/core';
import type {Observable} from 'rxjs';
import type {
  BulkPreviewResult,
  Contact,
  ContactGroupListQuery,
  ContactGroupListResult,
  ContactsListQuery,
  ContactsListResult,
  CreateContactGroupPayload,
  DeleteContactPayload,
  ExcelColumnMapping,
  ExcelFirstStepResult,
  UpdateContactPayload,
} from '../types/contacts.types';

export interface ContactsApi {
  listContacts(query: ContactsListQuery): Observable<ContactsListResult>;
  getContact(groupId: string, contactId: string): Observable<Contact | null>;
  getContactWithEvents(
    groupId: string,
    contactId: string,
    eventNameById: Map<string, string>,
    groupName?: string,
  ): Observable<Contact | null>;
  createContact(groupId: string, payload: UpdateContactPayload & {mobile: string}): Observable<void>;
  updateContact(
    groupId: string,
    contactId: string,
    payload: UpdateContactPayload,
  ): Observable<void>;
  deleteContact(payload: DeleteContactPayload): Observable<void>;
  bulkPreview(groupId: string, mobiles: number[]): Observable<BulkPreviewResult>;
  bulkConfirm(groupId: string, key: string): Observable<void>;
  textUpload(groupId: string, file: File): Observable<BulkPreviewResult>;
  excelFirstStep(groupId: string, file: File): Observable<ExcelFirstStepResult>;
  excelSecondStep(
    groupId: string,
    key: string,
    columns: ExcelColumnMapping,
  ): Observable<BulkPreviewResult>;
  fileConfirm(groupId: string, key: string, shouldModifyExistContacts: boolean): Observable<void>;
  getExportUrl(groupId: string): string;
}

export const CONTACTS_API = new InjectionToken<ContactsApi>('CONTACTS_API');
